// Module
var code = "<span ng-if=\"$ctrl.yearFirst\">{{$ctrl.year}}/</span> <span ng-if=\"$ctrl.dayFirst\"> {{$ctrl.day}}/</span> <span> {{$ctrl.month}}</span> <span ng-if=\"!$ctrl.dayFirst\">/ {{$ctrl.day}}</span> <span ng-if=\"!$ctrl.yearFirst\">/ {{$ctrl.year}}</span> ";
// Exports
module.exports = code;